import React, { useState } from 'react';
import '../../App.css'
import PageHeader from '../../Components/Instructor_Dashboard/PageHeader';
import { Row,Col } from 'antd';

const Dashboard = () => {
  
  return (
    <div className='dashboard_page'>
       <PageHeader title={'Dashboard'}/>

       <Row className='dashboard_cards_div'>
         
         <Col className='dashboard_card'>
             <h1>5</h1>
             <p className='light_grey'>Number of courses</p>
         </Col>

         <Col className='dashboard_card'>
             <h1>5</h1>
             <p className='light_grey'>Number of enrolment</p>
         </Col>

         <Col className='dashboard_card'>
             <h1>$5</h1>
             <p className='light_grey'>Pending balance</p>
         </Col>

         <Col className='dashboard_card'>
             <h1>$54</h1>
             <p className='light_grey'>Requested withdrawl amount</p>
         </Col>
         
       </Row>
       
    </div>
  )
}

export default Dashboard
